/* eslint-disable camelcase */
/* eslint-disable no-useless-catch */
/* eslint-disable no-plusplus */
/* eslint-disable no-await-in-loop */
import { useCallback, useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useStatus, SUCCESS, ERROR } from '@rootstrap/redux-tools';

import { useNavigation, useSession, useToast } from 'hooks';
import capitalize from 'lodash/capitalize';
import parseError from 'utils/parseError';
import UserService from 'services/userService';
import { addWidgetAd } from 'state/actions/widgetAdAction';
import { routeWithProps } from 'utils/helpers';
import { routesPaths } from 'constants/routesPaths';
import { useParams } from 'react-router-dom';

export default () => {
  const dispatch = useDispatch();
  const {
    user: { id: celebrityId }
  } = useSession();
  const username = useRef();
  const { showToast } = useToast();
  const { goTo } = useNavigation();
  const [loading, setLoading] = useState(false);
  const { status, error } = useStatus(addWidgetAd);
  const [isOverLimit, setIsOverLimit] = useState(false);
  const { type } = useParams();
  const onSubmit = useCallback(
    async data => {
      setLoading(true);
      const formData = new FormData();
      Object.keys(data).forEach(key => {
        if (Array.isArray(data[key])) {
          if (key === 'episode_ids' || key === 'narrative_ids') {
            if (Array.isArray(data[key])) {
              data[key].forEach(id => {
                formData.append(`widget_ad[${key}][]`, id);
              });
            } else if (typeof data[key] === 'string') {
              const ids = data[key].split(',').map(id => id.trim());
              ids.forEach(id => {
                formData.append(`widget_ad[${key}][]`, id);
              });
            }
          } else if (key === 'widget_ad_images') {
            data[key].forEach((imgData, index) => {
              Object.keys(imgData).forEach(innerKey => {
                formData.append(`widget_ad[${key}][${index}][${innerKey}]`, imgData[innerKey]);
              });
            });
          }
        } else {
          if (key !== 'id') {
            formData.append(`widget_ad[${key}]`, data[key]);
          }
        }
      });

      try {
        const result = await dispatch(addWidgetAd(celebrityId, formData));
        if (result.error && result.error.overlimit) {
          setIsOverLimit(true);
          showToast('You have already uploaded the maximum number of ads.');
        }
      } catch (error) {
        console.error('Error submitting banner ad:', error);
      } finally {
        setLoading(false);
      }
    },
    [dispatch, celebrityId]
  );

  const getProfile = async () => {
    try {
      const { data } = await UserService.getProfile();
      username.current = data.user.username;
    } catch ({ response }) {
      throw parseError(response);
    }
  };

  useEffect(() => {
    getProfile();
  }, []);

  useEffect(() => {
    if (status === SUCCESS) {
      showToast('Widget Ad Created!');
      if (type) {
        window.history.back();
      } else {
        goTo(routeWithProps(routesPaths.adManager, { tab: 'widgetsAds' }));
      }
      dispatch(addWidgetAd.reset());
    }
    if (status === ERROR) {
      if (error === 'You have already uploaded maximum number of ads.') {
        setIsOverLimit(true);
      }
      dispatch(addWidgetAd.reset());
    }
  }, [status, dispatch, showToast]);

  return {
    onSubmit,
    status,
    loading,
    isOverLimit,
    error: capitalize(error)
  };
};
